import type { MobileTopNavAction } from "@circleco/compass/components/MobileTopNav";

import type {
  MobileTrailingActionsWithOptions,
  MobileTrailingOverride,
} from "@/react/components/Mobile/context/sectionTabs/types";

/**
 * Narrows a registrar's `MobileTrailingOverride` to its two structured
 * forms (`MobileTopNavAction[]` or `MobileTrailingActionsWithOptions`),
 * as opposed to a plain legacy `ReactNode`. Shared by `MobileDefaultTopBar`
 * and `BackArrowMobileTopBar` so both TopBars dispatch the same union the
 * same way.
 */
export const hasStructuredActions = (
  trailing: MobileTrailingOverride,
): trailing is MobileTopNavAction[] | MobileTrailingActionsWithOptions => {
  if (Array.isArray(trailing)) {
    const [first] = trailing;
    const isLikelyAction =
      typeof first === "object" && first !== null && "id" in first;

    if (
      process.env.NODE_ENV === "development" &&
      trailing.length > 0 &&
      !isLikelyAction
    ) {
      console.warn(
        "hasStructuredActions: array trailing content without an `id` on its first element - " +
          "if this is legacy ReactNode[] content rather than MobileTopNavAction[], wrap it in a " +
          "single element instead; arrays are always routed to the structured actions path.",
      );
    }
    return true;
  }
  return (
    typeof trailing === "object" && trailing !== null && "actions" in trailing
  );
};
